import {  Injectable } from '@angular/core';

@Injectable()
export class ErrorCodesService {
  static readonly virtualGiftCardPurchaseLimitMessage = `You've reached the maximum allowed gift card purchase attempts.`;
  static readonly virtualGiftCardPurchaseTemporarilyUnavailableMessage = `We're unable to process your digital gift card purchase right now. Please try again later.`;
  static readonly virtualGiftCardPurchaseTemporarilyUnavailableTitle = `Purchase Temporarily Unavailable`;
  static readonly virtualGiftCardPurchaseTemporarilyUnavailableCta = `Okay`;

  private static expiredLinkText = 'Sorry, the link has expired.';
  private static technicalIssue = `Oops, we're having a technical issue with our system. Please try again later.`;
  private static pickupLocationIsClosed = `Your pickup location is closed`;
  private static config: { [id: number]: string; } = {
    // Property
    10000: ErrorCodesService.technicalIssue ,
    8509: `Your order cannot be cancelled because it is already being prepared.` ,
    5054: `Oops, we ran into a problem unlinking your account. Please try again.` ,
    5052: `Uh-oh, the payment method wasn't approved. Would you please make sure the information you entered is correct?` ,
    5051: `Oops, we're unable to link your paypal account. Would you mind trying again?` ,
    5035: `Uh-oh, you've previously saved that same credit/debit card number.` ,
    5031: `Error processing your card.` ,
    5029: `Your card has been declined.` ,
    5019: `Oops, we're having a technical issue with our system. Please try again later.` ,
    5017: `To protect your account, Only 3 payment methods may exist at once` ,
    5014: `To protect your account, reloads will be available again in 24 hours.` ,
    5012: ` Uh-oh, the gift card and PIN you entered isn't valid. Please try again.` ,
    5009: ` Uh-oh, the gift card and PIN you entered isn't valid. Please try again.` ,
    5008: `Oops, we had a problem loading the payment on your gift card. Please try again.` ,
    5004: ` Oops, we're having trouble finding your gift card. Please try again later. ` ,
    5001: ` Uh-oh, the gift card and PIN you entered isn't valid. Please try again.` ,
    4107: `Uh-oh, the email you entered doesn't meet our requirements. Please make sure you entered it correctly and try again.` ,
    4106: `Uh-oh, looks like the zip code you submitted isn't valid. Please make sure you entered it correctly and try again.` ,
    4105: `Uh-oh, the email you entered doesn't meet our requirements. Please make sure you entered it correctly and try again.` ,
    4103: `Uh-oh, the last name you entered doesn't meet our requirements. Please make sure you entered it correctly and try again.` ,
    4102: `Uh-oh, the first name you entered doesn't meet our requirements. Please make sure you entered it correctly and try again.` ,
    4039: `Please enter a valid code`,
    4038: `Your code is for a different device`,
    4037: `To protect your account, we’ve locked it after several sign in attempts`,
    4036: `Your code has expired`,
    4035: `Your code has expired`,
    4005: `We couldn't save your profile changes. Please check your entries and try again.`,
    4057: `Your email and phone can only be updated when you sign in.`,
    4058: `We couldn't complete sign-in with that email. Please check the address and try again, or continue with your current email.`,
    4101: `Uh-oh, that email is already being used for another account. Please make sure you entered it correctly and try again or sign into your existing account.` ,
    4034: `Something went wrong with your code`,
    4055: `Too many attempts. Try again later.`,
    4063: `Incorrect code. Try again.`,
    4064: `This code has expired. Request a new code.`,
    4065: `Too many attempts. Request a new code.`,
    4066: `Verification attempts are limited. Contact Customer Care for help.`,
    4067: `Something went wrong. Try again.`,
    4024: `Uh-oh, we can't send your password because you haven't validated your email. Want us to send you another validation email?` ,
    4021: `Uh-oh, that email is already being used for another account. Please make sure you entered it correctly and try again or sign into your existing account.` ,
    4016: `You've used Google in the past to sign in. Would you like to continue using Google?` ,
    4015: `You've used Facebook in the past to sign in. Would you like to continue using Facebook?` ,
    4012: `Uh-oh, your login didn't work that time. Would you mind checking the email and password you entered?` ,
    4011: `Uh-oh, your login didn't work that time. Would you mind checking the email and password you entered?` ,
    4046: `Invalid number. Please enter a valid 10-digit U.S. mobile number and try again.` ,
    4007: `Uh-oh, the temporary password is no longer valid. We'll be glad to send you another one.` ,
    4002: `Uh-oh, your login didn't work that time. Would you mind checking the email and password you entered?` ,
    4001: `Uh-oh, your login didn't work that time. Would you mind checking the email and password you entered?` ,
    8530: `You have selected a Drive Thru only pickup time`,
    8529: `You have selected a Dine In only pickup time`,
    8009: ErrorCodesService.expiredLinkText,
    8004: ErrorCodesService.expiredLinkText,
    // too old
    8537: 'The order you have entered is over the 30 day limit.',
    // online order
    8533: 'The order you have entered has already been credited for a visit.',
    // already been claimed
    8534: 'The information you have entered has been used before.',
    // one claim per calendar day
    8535: `Users may only submit one visit per day.`,
    1005: `No Whataburger locations found in your zip code. Whataburger only sponsors charities in areas they serve.`,
    1006: `Your decision date must be scheduled at least 60 days in advance.`,
    8536: `The order number is incorrect.`,
    8541: ErrorCodesService.technicalIssue,
    8540: ErrorCodesService.technicalIssue,
    8505: ErrorCodesService.pickupLocationIsClosed,
    8511: ErrorCodesService.pickupLocationIsClosed,
    8543: `Please turn on your hazard lights. We'll bring your order to you shortly.`,
    8544: `Please turn on your hazard lights. We'll bring your order to you shortly.`,
    8601: `Amount is invalid`,
    8602: `Unknown error - please try again`,
    8603: `Invalid Image`,
    8604: `Message is invalid`,
    8605:`Invalid Recipient Name`,
    8606:`Invalid Recipient Email`,
    8607: `Invalid Sender Name`,
    8608: `Online Gift Card Transaction Limit reached. Please try again after some time`,
    8609:`The payment method used for this purchase is not valid`,
    8610: `Invalid Send Date`,
    8611:`Invalid Time Zone`,
    8612: `Online Gift Card is not active`,
    8613: `Online Gift Card not found`,
    8615: ErrorCodesService.virtualGiftCardPurchaseLimitMessage,
    8616: ErrorCodesService.virtualGiftCardPurchaseTemporarilyUnavailableMessage,
    8617: ErrorCodesService.virtualGiftCardPurchaseTemporarilyUnavailableMessage,
    9: `Exceeded Gift Card transfer count for the day`,
    7027: `Insufficient points to redeem for an order.`,
    7026: `Sorry, the item you selected is no longer available. Please select another item or check back later.`
  };

  static isVirtualGiftCardPurchaseLimitError(errorCode: number): boolean {
    return errorCode === 8615;
  }

  static isVirtualGiftCardPurchaseEligibilityError(errorCode: number): boolean {
    return errorCode === 8616 || errorCode === 8617;
  }
  
  static getErrorMessage (errorCode: any, message: any) {
    if (errorCode === undefined && (message === undefined || message === null)) {
      const returnVal = this.config[10000] as string;
      return returnVal;
    } else if (errorCode === undefined && message) {
      return message as string;
    } else {
      const mapped = this.config[Number(errorCode)];
      if (mapped) {
        return mapped;
      }
      return message as string;
    }
  }

}
